import get from 'lodash/get';

function singleValueMatcher(selections, value) {
  if (!selections.length) {
    return true;
  }

  if (!value) {
    return false;
  }

  return selections.includes(value);
}

function multipleValueMatcher(selections, value) {
  if (!selections.length) {
    return true;
  }

  return selections.some(field => value.includes(field));
}

export function hasMatchingGenders(line, selectedGenders) {
  return multipleValueMatcher(selectedGenders, get(line, 'genders'));
}

export function hasMatchingProductTag(line, selectedProductTags) {
  return singleValueMatcher(selectedProductTags, get(line, 'productTag'));
}

export function hasMatchingProduct(line, selectedProducts) {
  return singleValueMatcher(selectedProducts, get(line, 'productId'));
}

export function hasMatchingCategories(line, selectedCategories) {
  return multipleValueMatcher(selectedCategories, get(line, 'categories'));
}
